export const hashString = (s: string) => {
  const date = new Date().getTime();
  const hashed = `${s}${date}`.split("").reduce((a, b) => {
    a = (a << 5) - a + b.charCodeAt(0);
    return a & a;
  }, 0);

  return `ZF_${Math.abs(hashed)}`;
};
